/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ApplicationRef, NgModuleRef} from '@angular/core';
import {createNewHosts} from '@angularclass/hmr';
import {AppModule} from './app/app.module';

export const hmrBootstrap = (module: any, bootstrap: () => Promise<NgModuleRef<AppModule>>) => {
    let ngModule: NgModuleRef<AppModule>;

    // tell webpack that we accept hot reloading
    module.hot.accept();

    // do the standard bootstrap of angular and save a reference to ngModule
    bootstrap()
        .then(mod => {
            ngModule = mod;
        })
        // eslint-disable-next-line no-console
        .catch((err: unknown) => console.log('HMR botstrap error: ', err));

    // destroy the old components and make the fresh ones visible
    module.hot.dispose(() => {
        const appRef = ngModule.injector.get(ApplicationRef);
        const elements = appRef.components.map(c => c.location.nativeElement);
        const makeVisible = createNewHosts(elements);
        ngModule.destroy();
        makeVisible();
    });
};
